import { useEffect, useState } from "react";
import { useI18n } from "../I18nContext";
import { FLOW_FILL } from "./FlowsFill";

const NOTE_KEY = "tb-flow-workbook-v2";

const VIEW_LABEL = {
  public: { en: "Public", fr: "Public" },
  founder: { en: "Founder view", fr: "Vue fondateur" },
  cofounder: { en: "Co-founder view", fr: "Vue cofondateur" },
  accelerator: { en: "Accelerator view", fr: "Vue accélérateur" },
  advisor: { en: "Advisor view", fr: "Vue conseiller" },
  admin: { en: "Admin view", fr: "Vue admin" },
};

const LAB_ACCOUNTS = [
  { view: "founder", name: "Maya Chen", company: "Northstar Bio", email: "founder@test.tb", pw: "Test12345!" },
  { view: "cofounder", name: "Jordan Hale", company: "Northstar Bio", email: "cofounder@test.tb", pw: "Test12345!" },
  { view: "accelerator", name: "Camille Okonkwo", company: "Northstar Accelerator", email: "accelerator@test.tb", pw: "Test12345!" },
  { view: "advisor", name: "Léa Moreau", company: "Climara Advisory", email: "coach@test.tb", pw: "Test12345!" },
  { view: "advisor", name: "Tom Berger", company: "Deep Signal", email: "coach2@test.tb", pw: "Test12345!" },
  { view: "admin", name: "Admin", company: "TractionBoard", email: "admin@tractionboard.ai", pw: "TractionBoard2026!" },
];

function li(items) {
  return (
    <ul>
      {items.map((x) => (
        <li key={x}>{x}</li>
      ))}
    </ul>
  );
}

const FLOWS = [
  {
    id: "f1",
    titleEn: "Get in",
    titleFr: "Entrer sur TB",
    meta: "/ · /register · /login · waitlist · set password",
    steps: [
      {
        n: "1.0",
        views: ["public"],
        url: "/",
        titleEn: "Landing (top of funnel)",
        titleFr: "Page d’accueil (entrée marketing)",
        en: li(["Marketing site, not the logged-in loop.", "Book first advisory session / See how it works.", "EN / FR on the public site."]),
        fr: li(["Site marketing, hors boucle connectée.", "Réserver une première rencontre / Voir comment ça marche.", "EN / FR sur le site public."]),
        shots: [{ src: "/flows/img/g-public-landing.png", cap: "Public — landing" }],
      },
      {
        n: "1.1",
        views: ["public"],
        url: "/register",
        titleEn: "Sign up (waitlist or open)",
        titleFr: "Inscription (liste d’attente ou ouverte)",
        en: li(["Create your account. Invite-only banner when signup mode is waitlist.", "I am a… Founder / Advisor / Provider / Fund manager / Accelerator — this sets the role, not a named program.", "Language drives the invite email.", "Request access (waitlist) or Create account (open)."]),
        fr: li(["Créer votre compte. Bandeau invitation si le mode est liste d’attente.", "Je suis… Fondateur / Conseiller / Fournisseur / Gestionnaire de fonds / Accélérateur — le rôle, pas un programme nommé.", "La langue pilote le courriel d’invitation.", "Demander l’accès (liste d’attente) ou Créer un compte (ouvert)."]),
        shots: [
          { src: "/flows/img/g-public-register.png", cap: "Public — register (top)" },
          { src: "/flows/img/g-public-register-role.png", cap: "Public — role + language + consents" },
        ],
      },
      {
        n: "1.2",
        views: ["admin"],
        url: "/app/admin · Waitlist",
        titleEn: "Admin approve",
        titleFr: "Approbation admin",
        en: li(["Signup mode: Invite-only vs Open.", "Pending row: name, email, localized role, company, note.", "Approve sends a 7-day set-password email."]),
        fr: li(["Mode : Sur invitation vs Ouvert.", "Ligne : nom, courriel, rôle traduit, entreprise, note.", "Approuver envoie un courriel (7 jours) pour définir le mot de passe."]),
        shots: [{ src: "/flows/img/g-admin-waitlist.png", cap: "Admin — waitlist + signup mode" }],
      },
      {
        n: "1.3",
        views: ["public"],
        url: "email",
        titleEn: "Set-password email",
        titleFr: "Courriel définir le mot de passe",
        email: true,
        en: (
          <>
            <p>Subject: TractionBoard — Welcome, your access is ready</p>
            <p>Hi {"{name}"}, your request was approved. Button: Set my password · 7 days.</p>
          </>
        ),
        fr: (
          <>
            <p>Objet : TractionBoard — Bienvenue, votre accès est prêt</p>
            <p>Bonjour {"{name}"}, votre demande a été approuvée. Bouton : Définir mon mot de passe · 7 jours.</p>
          </>
        ),
        shots: [
          { src: "/flows/img/f1-13-email-fr.png", cap: "Email preview FR (Resend stub locally)" },
          { src: "/flows/img/f1-13-email-en.png", cap: "Email preview EN" },
        ],
      },
      {
        n: "1.4",
        views: ["public"],
        url: "/reset-password/{token}",
        titleEn: "Set password, then login / forgot",
        titleFr: "Définir le mot de passe, puis connexion / oubli",
        en: li(["Set a new password · Confirm · Update. Stay on success with Log in.", "Login: Email / Password / EN–FR / Forgot password?", "Lab: founder@test.tb / Test12345! (same pattern for cofounder, accelerator, coach)."]),
        fr: li(["Nouveau mot de passe · Confirmer · Mettre à jour. Succès + Se connecter.", "Connexion : Courriel / Mot de passe / EN–FR / Mot de passe oublié ?", "Lab : founder@test.tb / Test12345! (même logique pour les autres rôles)."]),
        shots: [
          { src: "/flows/img/f1-14-reset-fr.png", cap: "Public — set password" },
          { src: "/flows/img/g-public-login.png", cap: "Public — login" },
          { src: "/flows/img/g-public-forgot.png", cap: "Public — forgot password" },
        ],
      },
    ],
  },
  {
    id: "f2",
    titleEn: "Connect",
    titleFr: "Connecter",
    meta: "/app/community",
    steps: [
      {
        n: "2.1",
        views: ["founder", "cofounder"],
        url: "/app/community",
        titleEn: "Founder community",
        titleFr: "Communauté — fondateur",
        en: li(["Connect with advisors, accelerators, and other founders.", "Mine vs Directory. Connections see submitted metrics / roadmap / frameworks."]),
        fr: li(["Se connecter à des conseillers, accélérateurs et autres fondateurs.", "Mes connexions vs annuaire. Les connexions voient les instantanés soumis."]),
        shots: [{ src: "/flows/img/g-founder-community.png", cap: "Founder — community" }],
      },
      {
        n: "2.2",
        views: ["accelerator"],
        url: "/app/community",
        titleEn: "Accelerator community",
        titleFr: "Communauté — accélérateur",
        en: li(["Same page, accelerator header. Connections include advisors and founders in the program workspace."]),
        fr: li(["Même page, en-tête accélérateur. Connexions : conseillers et fondateurs du workspace."]),
        shots: [{ src: "/flows/img/g-accel-community.png", cap: "Accelerator — community" }],
      },
    ],
  },
  {
    id: "f3",
    titleEn: "Book a meeting",
    titleFr: "Réserver une rencontre",
    meta: "/app/bookings · /app/sessions/new",
    steps: [
      {
        n: "3.1",
        views: ["founder", "cofounder"],
        url: "/app/bookings",
        titleEn: "Founder bookings",
        titleFr: "Réservations — fondateur",
        en: li(["Upcoming / past. Schedule a meeting or a mandate.", "Teammate 1:1 vs advisory — header shows Founder."]),
        fr: li(["À venir / passées. Planifier une rencontre ou un mandat.", "1:1 collègue vs advisory — en-tête Fondateur."]),
        shots: [{ src: "/flows/img/g-founder-bookings.png", cap: "Founder — bookings" }],
      },
      {
        n: "3.2",
        views: ["founder"],
        url: "/app/sessions/new",
        titleEn: "Schedule (person, time, recurrence)",
        titleFr: "Planifier (personne, horaire, récurrence)",
        en: li(["With = a Community connection. Recurrence: none / weekly. Optional title, rate, meeting link."]),
        fr: li(["Avec = une connexion Communauté. Récurrence : aucune / chaque semaine. Titre, tarif, lien optionnels."]),
        shots: [{ src: "/flows/img/g-founder-new-session.png", cap: "Founder — new session" }],
      },
      {
        n: "3.3",
        views: ["accelerator"],
        url: "/app/bookings",
        titleEn: "Accelerator bookings",
        titleFr: "Réservations — accélérateur",
        en: li(["Sees connected companies’ meetings (shared), including teammate 1:1s tagged colleague."]),
        fr: li(["Voit les rencontres des entreprises connectées (partagées), y compris les 1:1 collègues."]),
        shots: [{ src: "/flows/img/g-accel-bookings.png", cap: "Accelerator — bookings" }],
      },
      {
        n: "3.4",
        views: ["advisor"],
        url: "/app/bookings",
        titleEn: "Advisor bookings",
        titleFr: "Réservations — conseiller",
        en: li(["Same bookings UI; header shows Advisor. Empty until connected and booked."]),
        fr: li(["Même UI; en-tête Conseiller. Vide tant qu’il n’y a pas de connexion + réservation."]),
        shots: [{ src: "/flows/img/g-advisor-bookings.png", cap: "Advisor — bookings" }],
      },
    ],
  },
  {
    id: "f4",
    titleEn: "Run the meeting",
    titleFr: "Faire la rencontre",
    meta: "before → notes → after → transcript → AI",
    steps: [
      {
        n: "4.1",
        views: ["founder", "cofounder", "advisor", "accelerator"],
        url: "/app/sessions/{id}",
        titleEn: "Before / during / after",
        titleFr: "Avant / pendant / après",
        en: li(["Paste Meet / Zoom / Teams URL.", "Before form: my prep / their prep.", "Live notes: everyone / accelerator / private.", "After form, transcript, AI summary — private notes stay private."]),
        fr: li(["Coller l’URL Meet / Zoom / Teams.", "Formulaire avant : ma / sa préparation.", "Notes live : tout le monde / accélérateur / privé.", "Après, transcript, résumé IA — les notes privées restent privées."]),
        shots: [{ src: "/flows/img/g-founder-session.png", cap: "Founder — session (before form)" }],
      },
    ],
  },
  {
    id: "f5",
    titleEn: "Company picture",
    titleFr: "Portrait entreprise",
    meta: "/app/portfolio — founder metrics/roadmap/framework/docs",
    steps: [
      {
        n: "5.1",
        views: ["founder", "cofounder"],
        url: "/app/portfolio",
        titleEn: "Founder portfolio",
        titleFr: "Portfolio fondateur",
        en: li(["Tabs: Metrics, Roadmap, Frameworks, Documents.", "Save & submit to share the latest snapshot with connections."]),
        fr: li(["Onglets : Métriques, Feuille de route, Méthodologies, Documents.", "Enregistrer & soumettre pour partager l’instantané avec les connexions."]),
        shots: [
          { src: "/flows/img/g-founder-portfolio.png", cap: "Founder — metrics" },
          { src: "/flows/img/g-founder-roadmap.png", cap: "Founder — roadmap" },
          { src: "/flows/img/g-founder-documents.png", cap: "Founder — documents" },
        ],
      },
    ],
  },
  {
    id: "f6",
    titleEn: "Mandate",
    titleFr: "Mandat",
    meta: "/app/mandates",
    steps: [
      {
        n: "6.1",
        views: ["founder", "advisor"],
        url: "/app/mandates",
        titleEn: "Propose → accept → milestones",
        titleFr: "Proposer → accepter → jalons",
        en: li(["Structured advisor↔founder engagement: scope, deliverables, milestones, payment.", "Empty until someone creates + Nouveau mandat."]),
        fr: li(["Engagement structuré conseiller↔fondateur : portée, livrables, jalons, paiement.", "Vide jusqu’à + Nouveau mandat."]),
        shots: [{ src: "/flows/img/g-founder-mandates.png", cap: "Founder — mandates" }],
      },
    ],
  },
  {
    id: "f7",
    titleEn: "Team",
    titleFr: "Équipe",
    meta: "/app/team",
    steps: [
      {
        n: "7.1",
        views: ["founder", "cofounder"],
        url: "/app/team",
        titleEn: "Invite co-founder, shared company",
        titleFr: "Inviter un cofondateur, workspace partagé",
        en: li(["Primary founder is always co-founder. Mark teammates as co-founders (Living Doc approvers).", "Invite a teammate. Shared metrics, roadmap, frameworks, documents, 1:1s."]),
        fr: li(["Le fondateur principal est toujours cofondateur. Marquer des coéquipiers (approbateurs Living Doc).", "Inviter un coéquipier. Métriques, feuille de route, méthodologies, docs et 1:1 partagés."]),
        shots: [{ src: "/flows/img/g-founder-team.png", cap: "Founder — team (Maya + Jordan)" }],
      },
    ],
  },
  {
    id: "f8",
    titleEn: "Import people",
    titleFr: "Importer des personnes",
    meta: "Accelerator Portfolio · CSV",
    steps: [
      {
        n: "8.1",
        views: ["accelerator"],
        url: "/app/portfolio · Data management",
        titleEn: "CSV import / export",
        titleFr: "Import / export CSV",
        en: li(["Paste or choose a CSV (name, email, role, company, program, cohort, year).", "Download template. Import invites + auto-connect.", "Export founder data."]),
        fr: li(["Coller ou choisir un CSV (nom, courriel, rôle, entreprise, programme, cohorte, année).", "Télécharger le modèle. L’import invite et auto-connecte.", "Exporter les données fondateurs."]),
        shots: [{ src: "/flows/img/g-accel-import.png", cap: "Accelerator — CSV import / export" }],
      },
    ],
  },
  {
    id: "f9",
    titleEn: "Company funnel",
    titleFr: "Entonnoir entreprises",
    meta: "/app/portfolio — accelerator companies board",
    steps: [
      {
        n: "9.1",
        views: ["accelerator"],
        url: "/app/portfolio",
        titleEn: "Stages + click into a company",
        titleFr: "Étapes + ouvrir une entreprise",
        en: li(["Default stages: applicant → selected → assigned → alumni (customizable).", "Filters: founder, advisor, program, cohort, year.", "Click a company → shared portfolio + meetings."]),
        fr: li(["Étapes : candidat → sélectionné → assigné → anciens (personnalisables).", "Filtres : fondateur, conseiller, programme, cohorte, année.", "Cliquer une entreprise → portfolio partagé + rencontres."]),
        shots: [{ src: "/flows/img/g-accel-portfolio.png", cap: "Accelerator — company funnel" }],
      },
    ],
  },
  {
    id: "f10",
    titleEn: "Coach funnel",
    titleFr: "Entonnoir coachs",
    meta: "/app/portfolio — accelerator coaches + advisor pipeline",
    steps: [
      {
        n: "10.1",
        views: ["accelerator"],
        url: "/app/portfolio",
        titleEn: "Coaches / advisors board",
        titleFr: "Tableau Coachs / Conseillers",
        en: li(["Second kanban on the accelerator portfolio. Same stage model, notes, archive."]),
        fr: li(["Second kanban du portfolio accélérateur. Mêmes étapes, notes, archive."]),
        shots: [{ src: "/flows/img/g-accel-coaches.png", cap: "Accelerator — coach funnel" }],
      },
      {
        n: "10.2",
        views: ["advisor"],
        url: "/app/portfolio",
        titleEn: "Advisor’s own founder pipeline",
        titleFr: "Pipeline fondateurs du conseiller",
        en: li(["Advisors get a personal founder pipeline (not the accelerator dual board).", "Add companies from Community connections."]),
        fr: li(["Le conseiller a son propre pipeline fondateurs (pas le double tableau accélérateur).", "Ajouter des entreprises depuis les connexions Communauté."]),
        shots: [{ src: "/flows/img/g-advisor-portfolio.png", cap: "Advisor — founder pipeline" }],
      },
    ],
  },
  {
    id: "f11",
    titleEn: "Watch the meetings",
    titleFr: "Suivre les rencontres",
    meta: "Accelerator bookings of connected companies",
    steps: [
      {
        n: "11.1",
        views: ["accelerator"],
        url: "/app/bookings",
        titleEn: "Shared notes, not private",
        titleFr: "Notes partagées, pas les privées",
        en: li(["Accelerator sees connected-company bookings, shared notes, transcripts, summaries.", "Private notes stay off this view."]),
        fr: li(["L’accélérateur voit les réservations des entreprises connectées, notes partagées, transcripts, résumés.", "Les notes privées n’apparaissent pas ici."]),
        shots: [{ src: "/flows/img/g-accel-bookings.png", cap: "Accelerator — company meetings" }],
      },
    ],
  },
  {
    id: "f12",
    titleEn: "Profile",
    titleFr: "Profil",
    meta: "/app/u/{id}",
    steps: [
      {
        n: "12.1",
        views: ["founder", "advisor", "accelerator"],
        url: "/app/u/{uid}",
        titleEn: "Role card + settings",
        titleFr: "Fiche rôle + paramètres",
        en: li(["Name, headline, role pill, company, bio, links, meetings tab.", "Header always shows whose view you are in (Founder / Advisor / Accelerator)."]),
        fr: li(["Nom, accroche, pastille de rôle, entreprise, bio, liens, onglet rencontres.", "L’en-tête indique toujours la vue (Fondateur / Conseiller / Accélérateur)."]),
        shots: [{ src: "/flows/img/g-founder-profile.png", cap: "Founder — profile" }],
      },
    ],
  },
  {
    id: "f13",
    titleEn: "Frameworks",
    titleFr: "Méthodologies",
    meta: "/app/frameworks · Toolbox",
    steps: [
      {
        n: "13.1",
        views: ["founder", "advisor", "accelerator"],
        url: "/app/frameworks",
        titleEn: "Use or build diagnostics",
        titleFr: "Utiliser ou créer des diagnostics",
        en: li(["Shared with you vs library. Advisors / accelerators / funds / providers can create theirs."]),
        fr: li(["Partagées avec vous vs bibliothèque. Conseillers / accélérateurs / fonds / fournisseurs peuvent créer les leurs."]),
        shots: [{ src: "/flows/img/g-founder-frameworks.png", cap: "Founder — frameworks library" }],
      },
    ],
  },
  {
    id: "f14",
    titleEn: "Offers and services",
    titleFr: "Offres et services",
    meta: "/app/toolbox · /app/solutions",
    steps: [
      {
        n: "14.1",
        views: ["founder", "advisor", "accelerator"],
        url: "/app/toolbox",
        titleEn: "Toolbox catalog",
        titleFr: "Catalogue boîte à outils",
        en: li(["Frameworks + Offers and services (provider solutions, packaged programs)."]),
        fr: li(["Méthodologies + Offres et services (solutions fournisseurs, programmes packagés)."]),
        shots: [{ src: "/flows/img/g-founder-toolbox.png", cap: "Founder — toolbox" }],
      },
    ],
  },
  {
    id: "f15",
    titleEn: "Company Brain",
    titleFr: "Brain entreprise",
    meta: "Journal / Memory / Living Docs — gated (journal_enabled or admin)",
    steps: [
      {
        n: "15.1",
        views: ["admin", "founder"],
        url: "/app/journal · /app/memory · /app/docs",
        titleEn: "Journal, Memory, Docs",
        titleFr: "Journal, Mémoire, Docs",
        en: li(["Only if Journal / Brain is on for the account (admins always).", "Journal: team reflection. Memory: what the Brain sees. Docs: living docs + approvals."]),
        fr: li(["Uniquement si Journal / Brain est activé (admins toujours).", "Journal : réflexion d’équipe. Mémoire : ce que le Brain voit. Docs : documents vivants + approbations."]),
        shots: [
          { src: "/flows/img/g-admin-journal.png", cap: "Admin — journal (gated feature)" },
          { src: "/flows/img/g-admin-memory.png", cap: "Admin — memory" },
          { src: "/flows/img/g-admin-docs.png", cap: "Admin — living docs" },
        ],
      },
    ],
  },
  {
    id: "f16",
    titleEn: "Admin",
    titleFr: "Admin",
    meta: "/app/admin",
    steps: [
      {
        n: "16.1",
        views: ["admin"],
        url: "/app/admin",
        titleEn: "Console: users, waitlist, signup mode",
        titleFr: "Console : utilisateurs, liste d’attente, mode d’inscription",
        en: li(["Overview KPIs. Users: role, reset password, journal flag.", "Waitlist + signup mode. This Flow workbook lives on the Flow pill."]),
        fr: li(["KPIs. Utilisateurs : rôle, reset mot de passe, flag journal.", "Liste d’attente + mode d’inscription. Ce classeur est l’onglet Flow."]),
        shots: [
          { src: "/flows/img/g-admin-overview.png", cap: "Admin — overview" },
          { src: "/flows/img/g-admin-users.png", cap: "Admin — users" },
          { src: "/flows/img/g-admin-waitlist.png", cap: "Admin — waitlist" },
        ],
      },
    ],
  },
];

function loadNotes() {
  try {
    return JSON.parse(localStorage.getItem(NOTE_KEY) || "{}");
  } catch {
    return {};
  }
}

function Note({ id, placeholder, defaultValue = "", minHeight = 88 }) {
  const [val, setVal] = useState(() => {
    const saved = loadNotes();
    return saved[id] != null ? saved[id] : defaultValue;
  });
  const onChange = (e) => {
    const v = e.target.value;
    setVal(v);
    const all = loadNotes();
    all[id] = v;
    localStorage.setItem(NOTE_KEY, JSON.stringify(all));
  };
  return (
    <textarea
      className="tb-flow-note"
      style={{ minHeight }}
      value={val}
      placeholder={placeholder}
      onChange={onChange}
      data-testid={`flow-note-${id}`}
    />
  );
}

function Bi({ fr, en, show }) {
  return (
    <div className={`tb-flow-bi ${show}`}>
      {(show === "both" || show === "fr") && (
        <div className="tb-flow-col">
          <h4>FR</h4>
          {fr}
        </div>
      )}
      {(show === "both" || show === "en") && (
        <div className="tb-flow-col">
          <h4>EN</h4>
          {en}
        </div>
      )}
    </div>
  );
}

function Shot({ src, caption }) {
  return (
    <figure className="tb-flow-shot">
      <img src={src} alt={caption} />
      <figcaption>{caption}</figcaption>
    </figure>
  );
}

function ViewPills({ views, lang }) {
  return (
    <span className="tb-flow-views">
      {views.map((v) => (
        <span key={v} className={`tb-flow-view ${v}`}>
          {VIEW_LABEL[v]?.[lang] || v}
        </span>
      ))}
    </span>
  );
}

function LabStrip({ lang }) {
  return (
    <div className="tb-flow-lab" data-testid="flow-lab-accounts">
      {LAB_ACCOUNTS.map((a) => (
        <div key={a.email}>
          <span className={`tb-flow-view ${a.view}`}>{VIEW_LABEL[a.view]?.[lang]}</span>
          <strong>{a.name}</strong>
          <span className="tb-muted">{a.company}</span>
          <div><code>{a.email}</code> / <code>{a.pw}</code></div>
        </div>
      ))}
    </div>
  );
}

function FlowBody({ flow, show, lang, t }) {
  const fill = FLOW_FILL[flow.id] || {};
  return (
    <>
      {flow.steps.map((s) => (
        <div className="tb-flow-step" key={s.n}>
          <h3>
            {s.n} {lang === "fr" ? s.titleFr : s.titleEn}
            <ViewPills views={s.views} lang={lang} />
          </h3>
          {s.url ? <div className="tb-flow-url">{s.url}</div> : null}
          <Bi show={show} fr={s.fr} en={s.en} />
          {s.email ? <p className="tb-muted" style={{ fontSize: "0.85rem" }}>{t("adminFlows.emailStub")}</p> : null}
          {s.shots?.length ? (
            <div className="tb-flow-shots">
              {s.shots.map((sh) => (
                <Shot key={sh.src} src={sh.src} caption={sh.cap} />
              ))}
            </div>
          ) : null}
          <Note id={`${flow.id}-${s.n}`} placeholder={t("adminFlows.stepNotes")} defaultValue={fill.steps?.[s.n] || ""} />
        </div>
      ))}
      <div className="tb-flow-step">
        <h3>{t("adminFlows.recs")}</h3>
        <div className="tb-flow-recs">
          <div className="tb-flow-rec must">
            <h4>Must</h4>
            <Note id={`${flow.id}-must`} defaultValue={fill.must || ""} minHeight={140} />
          </div>
          <div className="tb-flow-rec nice">
            <h4>Nice</h4>
            <Note id={`${flow.id}-nice`} defaultValue={fill.nice || ""} minHeight={140} />
          </div>
        </div>
        <p className="tb-muted" style={{ fontSize: "0.8rem", marginTop: 12 }}>{t("adminFlows.workingNotes")}</p>
        <Note id={`${flow.id}-notes`} placeholder="Notes" defaultValue={fill.notes || ""} minHeight={120} />
      </div>
    </>
  );
}

export default function FlowsTab() {
  const { t, lang } = useI18n();
  const [flowId, setFlowId] = useState("f1");
  const [show, setShow] = useState("both");
  const flow = FLOWS.find((f) => f.id === flowId) || FLOWS[0];

  useEffect(() => {
    setShow(lang === "fr" ? "fr" : "en");
  }, [lang]);

  return (
    <div data-testid="admin-flows">
      <p className="tb-muted" style={{ marginTop: 0, marginBottom: 12 }}>{t("adminFlows.intro")}</p>
      <LabStrip lang={lang === "fr" ? "fr" : "en"} />
      <div className="tb-admin-tabs" data-testid="admin-flow-lang">
        <button type="button" className={show === "both" ? "on" : ""} onClick={() => setShow("both")}>EN+FR</button>
        <button type="button" className={show === "en" ? "on" : ""} onClick={() => setShow("en")}>EN</button>
        <button type="button" className={show === "fr" ? "on" : ""} onClick={() => setShow("fr")}>FR</button>
      </div>
      <div className="tb-admin-tabs" data-testid="admin-flow-nav">
        {FLOWS.map((f) => (
          <button
            key={f.id}
            type="button"
            className={flowId === f.id ? "on" : ""}
            onClick={() => setFlowId(f.id)}
            data-testid={`admin-flow-${f.id}`}
          >
            {f.id.replace("f", "")}. {lang === "fr" ? f.titleFr : f.titleEn}
          </button>
        ))}
      </div>
      <div className="tb-block tb-flow-card">
        <h2 className="tb-h2" style={{ marginTop: 0 }}>
          Flow {flow.id.replace("f", "")} — {lang === "fr" ? flow.titleFr : flow.titleEn}
        </h2>
        {flow.meta ? <p className="tb-muted" style={{ marginTop: 0 }}>{flow.meta}</p> : null}
        <FlowBody key={flow.id} flow={flow} show={show} lang={lang === "fr" ? "fr" : "en"} t={t} />
      </div>
    </div>
  );
}
